import { useEffect } from "react";
import { formatDate } from "../lib/formatDate";
import { setPageMeta } from "../lib/pageMeta";

// Public changelog — reachable at /changelog, no auth required.
// Mirrors the PrivacyPage / TermsPage shell so the three legal
// pages render with one visual language.
//
// To add an entry: prepend a new object to CHANGELOG below. The
// data is the source of truth; the JSX body is a thin loop over
// it. `date` is an ISO date string the renderer formats UTC-safe
// via lib/formatDate so the header never drifts a day for readers
// east or west of London.

interface ChangelogEntry {
  date: string; // YYYY-MM-DD
  items: string[];
}

const CHANGELOG: ChangelogEntry[] = [
  {
    date: "2026-04-21",
    items: [
      "CaseThread launches in public beta.",
      "AI-powered timeline, key facts, and party extraction from your forwarded correspondence.",
      "Professional PDF and Word dossier exports ready for lawyers, regulators, or ombudsmen.",
      "Email forwarding with automatic record creation — every message filed and timestamped.",
      "Multi-provider AI support: Anthropic Claude, OpenAI, and Google Gemini.",
      "Free 30-day trial with 100 AI calls included.",
    ],
  },
];

export default function ChangelogPage() {
  useEffect(() => {
    setPageMeta({
      title: "Changelog | CaseThread",
      description:
        "Recent updates to CaseThread — features shipped, fixes, and notable changes.",
      canonical: "https://casethread.app/changelog",
    });
  }, []);

  return (
    <div className="legal-page">
      <header className="legal-header">
        <a href="/welcome" className="legal-brand">
          CaseThread
        </a>
        <nav>
          <a href="/privacy">Privacy</a>
          <a href="/terms">Terms</a>
        </nav>
      </header>
      <main className="legal-main">
        <h1>Changelog</h1>
        <p className="muted">
          What's changed and when. Most recent at the top.
        </p>

        <div className="changelog-list">
          {CHANGELOG.map((entry) => (
            <section key={entry.date} className="changelog-entry">
              <h2 className="changelog-date">
                {formatDate(entry.date, "long") || entry.date}
              </h2>
              <ul className="changelog-items">
                {entry.items.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </section>
          ))}
        </div>
      </main>
    </div>
  );
}
